import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { SALENG_SHOP_API_PROD } from "./../config";

const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

const getAccessToken = () => localStorage.getItem("accessToken") || null;

const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const getIds = () => {
  const decoded = decodeToken();
  return {
    accessToken: getAccessToken(),
    userId: decoded?.id ?? null,
    shopId: decoded?.shopId ?? null,
    branchId: decoded?.branchId ?? null,
    isMain: decoded?.isMain ?? false,
  };
};

export const createCustomer = (payload) => {
  const { shopId, branchId } = getIds();

  return axios.post(
    `${SALENG_SHOP_API}/customer`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const updateCustomer = (payload, id) => {
  const { shopId, branchId } = getIds();

  return axios.patch(
    `${SALENG_SHOP_API}/customer/${id}`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const upload = (formData) => {
  return axios.post(`${SALENG_SHOP_API}/files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getCustomers = (customerType) => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer`,
    {
      params: {
        shopId,
        branchId,
        customerType
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getCustomersList = () => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer/list`,
    {
      params: {
        shopId: shopId,
        branchId: branchId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getCustomersById = (id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getGroup = () => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer/groups`,
    {
      params: {
        shopId: shopId,
        branchId: branchId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const addGroup = (payload) => {
  const { shopId, branchId } = getIds();

  return axios.post(
    `${SALENG_SHOP_API}/customer/group`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getCustomerByGroup = (id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/groups/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const addCustomerToGroup = (payload) => {
  return axios.post(
    `${SALENG_SHOP_API}/customer/group/add-customer`,
    { ...payload },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const updateCustomeGroup = (payload) => {
  return axios.post(
    `${SALENG_SHOP_API}/customer/group/remove-customer`,
    { ...payload },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};